// src/app/views/pages_admin/user_group/userGroup-routes.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const PricePolicy = Loadable(lazy(() => import("./PricePolicy")));

const routes = Object.values(EXAM_TYPES).map(examType => ({
  path: `${examType.pathPrefix}/price-policy`,
  element: <PricePolicy />
}));

export default routes;